import { jwtDecode } from 'jwt-decode'

interface TokenDto {
  resourceId: string
  jti: string
  exp: number
}

export function decodeJwt(token: string): TokenDto | null {
  try {
    const decoded = jwtDecode<TokenDto>(token)
    return decoded
  } catch (error) {
    console.error('Hubo un error: Error decoding JWT ', error)
    return null
  }
}
